import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';


@Component({
  selector: 'eae-bottom-sheet',
  templateUrl: './eae-bottom-sheet.component.html',
  styleUrls: ['./eae-bottom-sheet.component.scss'],
})
export class EaeBottomSheetComponent implements OnInit {

  @Input()
  show: boolean = false

  @Input()
  title: string = ''

  @Input()
  subtitle: string = ''

  @Output() onClose = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  
  public clickedClose () {
    this.onClose.emit()
  }

}
